module.exports = __webpack_public_path__ + "img/021-hand.f8d41d91.png";